// src/components/AdminRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Bu bileşen, içine aldığı bir sayfayı (children) sadece admin ise gösterir.
// Admin bilgisi girişte AuthContext tarafından bir kez okunur; her sayfa geçişinde
// Firestore'a tekrar gitmeye gerek yok. AuthProvider profil yüklenene kadar
// çocukları çizmediği için burada ayrıca bekleme durumu yoktur.
function AdminRoute({ children }) {
  const { currentUser, isAdmin } = useAuth();

  if (!currentUser) return <Navigate to="/" />;
  return isAdmin ? children : <Navigate to="/home" />;
}

export default AdminRoute;
